import { PayeeStatus, EventType } from "#graphql/supergraphEnums";
import { DetailedPayeeLogFragment } from "#graphql/supergraphTypes";
import * as styles from "../../../shared/LogsList/styles.css";
import { LogsListConfig } from "../../../shared/LogsList/types";
import { cardTitle } from "./styles_vanilla.css";

/**
 * Configuration for rendering Payee logs using the generic LogsList component
 */
export const payeeLogsConfig: LogsListConfig<DetailedPayeeLogFragment> = {
  getIcon: (logEntry) => {
    if (logEntry.status === PayeeStatus.Rejected) {
      return "times-circle";
    }
    return "check-circle";
  },

  formatActionDescription: (logEntry) => {
    const userName = logEntry.user?.fullName || "Unknown User";

    switch (logEntry.eventType) {
      case EventType.Create:
        return `Payee created and submitted for review by ${userName}`;
      case EventType.Update:
        if (logEntry.status === PayeeStatus.Approved) {
          return `Payee approved by ${userName}`;
        } else if (logEntry.status === PayeeStatus.Rejected) {
          return `Reviewed and returned by ${userName}`;
        } else if (
          (logEntry.previousStatus === PayeeStatus.Rejected ||
            logEntry.previousStatus === PayeeStatus.Approved) &&
          logEntry.status === PayeeStatus.Pending
        ) {
          return `Payee edited and submitted for review by ${userName}`;
        }
        return `Payee updated by ${userName}`;
      default:
        return `Action performed by ${userName}`;
    }
  },

  shouldShowReason: (logEntry) => {
    return logEntry.status === PayeeStatus.Rejected && !!logEntry.reason;
  },

  getReason: (logEntry) => {
    return logEntry.reason;
  },

  reasonBoxClassName: styles.reasonBox,

  cardTitleClassName: cardTitle,

  cardTitle: undefined, // Will use default "LOG"
};
